var _rect, _path, _path2, _path3, _path4, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup800(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 133,
    height: 197,
    viewBox: "0 0 133 197",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.3159,
    y: 0.395979,
    width: 132.154,
    height: 195.733,
    rx: 7.03912,
    fill: "#2A2A2A",
    stroke: "#2A2A2A",
    strokeWidth: 0.454137
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.36283 0.623047C3.60064 0.623047 0.550781 3.67291 0.550781 7.4351V189.09C0.550781 192.852 3.60065 195.902 7.36284 195.902H125.438C129.201 195.902 132.25 192.852 132.25 189.09V7.4351C132.25 3.67291 129.201 0.623047 125.438 0.623047H7.36283ZM24.6208 29.2338C21.8618 29.2338 19.6253 31.4704 19.6253 34.2293V161.842C19.6253 164.601 21.8618 166.837 24.6208 166.837H108.636C111.395 166.837 113.632 164.601 113.632 161.842V34.2293C113.632 31.4704 111.395 29.2338 108.636 29.2338H24.6208Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6211 177.736C19.6211 174.977 21.8577 172.74 24.6166 172.74H108.632C111.391 172.74 113.627 174.977 113.627 177.736V189.543C113.627 189.794 113.424 189.997 113.173 189.997H20.0752C19.8244 189.997 19.6211 189.794 19.6211 189.543V177.736Z",
    fill: "#343434",
    fillOpacity: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.44922 183.64C6.44922 182.386 7.46584 181.369 8.7199 181.369H15.0778C16.3319 181.369 17.3485 182.386 17.3485 183.64V189.544C17.3485 189.794 17.1452 189.998 16.8944 189.998H6.90336C6.65254 189.998 6.44922 189.794 6.44922 189.544V183.64Z",
    fill: "#343434",
    fillOpacity: 0.8
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M115.898 183.64C115.898 182.386 116.915 181.369 118.169 181.369H124.527C125.781 181.369 126.798 182.386 126.798 183.64V189.544C126.798 189.794 126.594 189.998 126.344 189.998H116.353C116.102 189.998 115.898 189.794 115.898 189.544V183.64Z",
    fill: "#343434",
    fillOpacity: 0.8
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6.44922,
    y: 170.016,
    width: 10.8993,
    height: 8.17446,
    rx: 2.27068,
    fill: "#343434",
    fillOpacity: 0.8
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 115.898,
    y: 170.016,
    width: 10.8993,
    height: 8.17446,
    rx: 2.27068,
    fill: "#343434",
    fillOpacity: 0.8
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 6.44922,
    y: 158.662,
    width: 10.8993,
    height: 8.17446,
    rx: 2.27068,
    fill: "#343434",
    fillOpacity: 0.8
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 115.898,
    y: 158.662,
    width: 10.8993,
    height: 8.17446,
    rx: 2.27068,
    fill: "#343434",
    fillOpacity: 0.8
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 6.44922,
    y: 146.854,
    width: 10.8993,
    height: 8.17446,
    rx: 2.27068,
    fill: "#343434",
    fillOpacity: 0.8
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 115.898,
    y: 146.854,
    width: 10.8993,
    height: 8.17446,
    rx: 2.27068,
    fill: "#343434",
    fillOpacity: 0.8
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 6.44922,
    y: 135.048,
    width: 10.8993,
    height: 8.17446,
    rx: 2.27068,
    fill: "#343434",
    fillOpacity: 0.8
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 115.898,
    y: 135.048,
    width: 10.8993,
    height: 8.17446,
    rx: 2.27068,
    fill: "#343434",
    fillOpacity: 0.8
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 6.44922,
    y: 123.239,
    width: 10.8993,
    height: 8.17446,
    rx: 2.27068,
    fill: "#343434",
    fillOpacity: 0.8
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 115.898,
    y: 123.239,
    width: 10.8993,
    height: 8.17446,
    rx: 2.27068,
    fill: "#343434",
    fillOpacity: 0.8
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 6.44922,
    y: 111.887,
    width: 10.8993,
    height: 8.17446,
    rx: 2.27068,
    fill: "#343434",
    fillOpacity: 0.8
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 115.898,
    y: 111.887,
    width: 10.8993,
    height: 8.17446,
    rx: 2.27068,
    fill: "#343434",
    fillOpacity: 0.8
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 6.44922,
    y: 100.079,
    width: 10.8993,
    height: 8.17446,
    rx: 2.27068,
    fill: "#343434",
    fillOpacity: 0.8
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 115.898,
    y: 100.079,
    width: 10.8993,
    height: 8.17446,
    rx: 2.27068,
    fill: "#343434",
    fillOpacity: 0.8
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 6.44922,
    y: 88.2715,
    width: 10.8993,
    height: 8.17446,
    rx: 2.27068,
    fill: "#343434",
    fillOpacity: 0.8
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 115.898,
    y: 88.2715,
    width: 10.8993,
    height: 8.17446,
    rx: 2.27068,
    fill: "#343434",
    fillOpacity: 0.8
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 6.44922,
    y: 76.4629,
    width: 10.8993,
    height: 8.17446,
    rx: 2.27068,
    fill: "#343434",
    fillOpacity: 0.8
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 115.898,
    y: 76.4629,
    width: 10.8993,
    height: 8.17446,
    rx: 2.27068,
    fill: "#343434",
    fillOpacity: 0.8
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 6.44922,
    y: 65.1104,
    width: 10.8993,
    height: 8.17446,
    rx: 2.27068,
    fill: "#343434",
    fillOpacity: 0.8
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 115.898,
    y: 65.1104,
    width: 10.8993,
    height: 8.17446,
    rx: 2.27068,
    fill: "#343434",
    fillOpacity: 0.8
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 6.44922,
    y: 53.3027,
    width: 10.8993,
    height: 8.17446,
    rx: 2.27068,
    fill: "#343434",
    fillOpacity: 0.8
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 115.898,
    y: 53.3027,
    width: 10.8993,
    height: 8.17446,
    rx: 2.27068,
    fill: "#343434",
    fillOpacity: 0.8
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 6.44922,
    y: 41.4951,
    width: 10.8993,
    height: 8.17446,
    rx: 2.27068,
    fill: "#343434",
    fillOpacity: 0.8
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 115.898,
    y: 41.4951,
    width: 10.8993,
    height: 8.17446,
    rx: 2.27068,
    fill: "#343434",
    fillOpacity: 0.8
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 6.44922,
    y: 29.6875,
    width: 10.8993,
    height: 8.17446,
    rx: 2.27068,
    fill: "#343434",
    fillOpacity: 0.8
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 115.898,
    y: 29.6875,
    width: 10.8993,
    height: 8.17446,
    rx: 2.27068,
    fill: "#343434",
    fillOpacity: 0.8
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 6.44922,
    y: 18.334,
    width: 10.8993,
    height: 8.17446,
    rx: 2.27068,
    fill: "#343434",
    fillOpacity: 0.8
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 115.898,
    y: 18.334,
    width: 10.8993,
    height: 8.17446,
    rx: 2.27068,
    fill: "#343434",
    fillOpacity: 0.8
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.44922 6.9805C6.44922 6.72969 6.65254 6.52637 6.90336 6.52637H16.8944C17.1452 6.52637 17.3485 6.72969 17.3485 6.9805V12.8843C17.3485 14.1383 16.3319 15.155 15.0778 15.155H8.7199C7.46584 15.155 6.44922 14.1383 6.44922 12.8843V6.9805Z",
    fill: "#343434",
    fillOpacity: 0.8
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M115.898 6.9805C115.898 6.72969 116.102 6.52637 116.353 6.52637H126.344C126.594 6.52637 126.798 6.72969 126.798 6.9805V12.8843C126.798 14.1383 125.781 15.155 124.527 15.155H118.169C116.915 15.155 115.898 14.1383 115.898 12.8843V6.9805Z",
    fill: "#343434",
    fillOpacity: 0.8
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6211 6.9805C19.6211 6.72969 19.8244 6.52637 20.0752 6.52637H113.173C113.424 6.52637 113.627 6.72969 113.627 6.9805V18.3339C113.627 21.0929 111.391 23.3294 108.632 23.3294H24.6166C21.8577 23.3294 19.6211 21.0929 19.6211 18.3339V6.9805Z",
    fill: "#343434",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup800);
export default __webpack_public_path__ + "static/media/Group 800.b0c3071795b9a9945c441f6cc43be2d2.svg";
export { ForwardRef as ReactComponent };